import React, { useEffect, useState } from 'react';
import { Button, Collapse, Dropdown, Input, Space } from 'antd';
import {
    ArrowDownOutlined,
    ArrowUpOutlined,
    MinusOutlined,
    PlusOutlined,
} from '@ant-design/icons';
import { filter, findIndex, map } from 'underscore';
import { connect } from 'react-redux';
import { change_app_setting_content } from '../actions/previewSideBar';
import { isExternalLink } from '../../../functions/isExternalLink';
import { Dots, Ok } from 'app/shared/assets';
import s from './index.module.scss';
import { v4 as uuid } from 'uuid';

const { Panel } = Collapse;

export const rowTypes = {
    text: 'text',
    img: 'img',
    imgs: 'imgs',
};

function newColumn() {
    return { id: uuid(), header: '', rows: [] };
}

function newImg() {
    return newRow(rowTypes.img, { width: '', height: '' });
}

function newRow(type, additional) {
    let props = {};
    switch (type) {
        case rowTypes.imgs:
            props = { imgs: [newImg()] };
            break;
        case rowTypes.img:
        case rowTypes.text:
            props = { value: '' };
            break;
    }
    return {
        id: uuid(),
        type,
        ...props,
        ...additional,
    };
}

export const swapArrayLoc = (arr, from, to) => {
    const copy = JSON.parse(JSON.stringify(arr));
    copy.splice(from, 1, copy.splice(to, 1, copy[from])[0]);
    return copy;
};

export const SettingsFooter = connect(
    (state) => ({ content: state.appState.setting.content }),
    (dispatch) => ({
        setSettings: (value) =>
            dispatch({ type: change_app_setting_content, data: value }),
    })
)(({ content, setSettings }) => {
    const { footer } = content || {};
    const { columns = [], equalColumnWidth } = footer || {};
    function setSetting(value) {
        setSettings({ ...content, footer: { ...footer, ...value } });
    }
    function onNewColumn() {
        setSetting({ columns: [...columns, newColumn()] });
    }
    function onNewRow(columnId, type) {
        setSetting({
            columns: map(columns, (column) =>
                column.id === columnId
                    ? { ...column, rows: [...column.rows, newRow(type)] }
                    : column
            ),
        });
    }
    function onDeleteColumn(columnId) {
        setSetting({
            columns: filter(columns, (column) => column.id !== columnId),
        });
    }
    function onDeleteRow(columnId, rowId) {
        return () => {
            setSetting({
                columns: map(columns, (column) =>
                    column.id === columnId
                        ? {
                              ...column,
                              rows: filter(
                                  column.rows,
                                  (row) => row.id !== rowId
                              ),
                          }
                        : column
                ),
            });
        };
    }
    function onUpdateColumn(columnId, value) {
        setSetting({
            columns: map(columns, (column) =>
                column.id === columnId ? { ...column, ...value } : column
            ),
        });
    }
    function onUpdateRow(columnId, rowId) {
        return (value) => {
            setSetting({
                columns: map(columns, (column) =>
                    column.id === columnId
                        ? {
                              ...column,
                              rows: map(column.rows, (row) =>
                                  row.id === rowId ? { ...row, ...value } : row
                              ),
                          }
                        : column
                ),
            });
        };
    }

    function onChangeOrderColumn(id, up) {
        const index = findIndex(columns, (column) => column.id === id);
        if (index === -1) return;
        setSetting({
            columns: swapArrayLoc(columns, index, up ? index - 1 : index + 1),
        });
    }

    function onChangeOrderRow(columnId, rowId) {
        return (up) => {
            setSetting({
                columns: map(columns, (column) => {
                    const index = findIndex(
                        column.rows,
                        (row) => row.id === rowId
                    );
                    if (index === -1) return column;
                    return column.id === columnId
                        ? {
                              ...column,
                              rows: swapArrayLoc(
                                  column.rows,
                                  index,
                                  up ? index - 1 : index + 1
                              ),
                          }
                        : column;
                }),
            });
        };
    }

    return (
        <Space direction={'vertical'} style={{ width: '100%' }}>
            <div className={s.wrap}>
                {equalColumnWidth ? (
                    <div
                        className={s.active_checkbox}
                        onClick={(e) => setSetting({ equalColumnWidth: false })}
                    >
                        <Ok />
                    </div>
                ) : (
                    <div
                        className={s.common_checkbox}
                        onClick={(e) => setSetting({ equalColumnWidth: true })}
                    ></div>
                )}
                <div
                    onClick={(e) =>
                        setSetting({ equalColumnWidth: !equalColumnWidth })
                    }
                >
                    Одинаковая ширина колонок
                </div>
            </div>
            <Button
                onClick={onNewColumn}
                icon={<PlusOutlined />}
                className={'add-new-column-btn'}
            >
                Добавить столбец
            </Button>
            <Collapse>
                {map(columns, (column, index, array) => {
                    const { id, header } = column;
                    return (
                        <Panel
                            header={header}
                            key={id}
                            extra={
                                <Space>
                                    <MinusOutlined
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            onDeleteColumn(id);
                                        }}
                                    />
                                    {index === 0 ? null : (
                                        <ArrowUpOutlined
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                onChangeOrderColumn(id, true);
                                            }}
                                        />
                                    )}
                                    {index === array.length - 1 ? null : (
                                        <ArrowDownOutlined
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                onChangeOrderColumn(id, false);
                                            }}
                                        />
                                    )}
                                </Space>
                            }
                        >
                            <Column
                                key={id}
                                column={column}
                                onUpdateColumn={onUpdateColumn}
                                onNewRow={onNewRow}
                                onDeleteRow={onDeleteRow}
                                onUpdateRow={onUpdateRow}
                                onChangeOrderRow={onChangeOrderRow}
                            />
                        </Panel>
                    );
                })}
            </Collapse>
        </Space>
    );
});

const items = [
    {
        key: rowTypes.text,
        label: 'Текст',
    },
    {
        key: rowTypes.imgs,
        label: 'Изображение',
    },
];

const RowTypes = ({ onMenuClick }) => {
    return (
        <Dropdown.Button menu={{ items, onClick: onMenuClick }}>
            Добавить строку
        </Dropdown.Button>
    );
};

const Column = ({
    column,
    onUpdateColumn,
    onNewRow,
    onChangeOrderRow,
    onUpdateRow,
    onDeleteRow,
}) => {
    const { header, id, rows } = column;
    const [dropdown, setDropdown] = useState(false);
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
            }}
            className="collapse-input"
        >
            <Input
                placeholder={'Название'}
                value={header}
                onChange={(value) =>
                    onUpdateColumn(id, {
                        header: value.target.value,
                    })
                }
            />
            <div className={s.row}>
                {/* <RowTypes
                    onMenuClick={(value) => {
                       
                        onNewRow(id, value.key);
                    }}
                /> */}
                <div
                    className={s.add_row}
                    onClick={() => setDropdown((prev) => !prev)}
                >
                    Добавить строку
                </div>
                <div
                    className={s.dots}
                    onClick={() => setDropdown((prev) => !prev)}
                >
                    <Dots />
                </div>
                {dropdown && (
                    <div className={s.dropdown}>
                        <div
                            onClick={() => {
                                onNewRow(id, 'text');
                                setDropdown((prev) => !prev);
                            }}
                        >
                            Текст
                        </div>
                        <div
                            onClick={() => {
                                onNewRow(id, 'imgs');
                                setDropdown((prev) => !prev);
                            }}
                        >
                            Изображение
                        </div>
                    </div>
                )}
            </div>
            {map(rows, ({ id: rowId, type, ...row }, index, array) => {
                return (
                    <Row
                        key={rowId}
                        type={type}
                        row={row}
                        onChange={onUpdateRow(id, rowId)}
                        onRemove={onDeleteRow(id, rowId)}
                        onChangeOrderRow={onChangeOrderRow(id, rowId)}
                        index={index}
                        array={array}
                        showUp={index === 0}
                        showBottom={index === array.length - 1}
                    />
                );
            })}
        </div>
    );
};

const Row = ({
    type,
    onChange,
    row,
    onRemove,
    onChangeOrderRow,
    showUp,
    showBottom,
}) => {
    const { value, link, imgs } = row;
    const [isSelectedLink, setIsSelectedLink] = useState(false);
    function onAddImg() {
        onChange({ imgs: [...imgs, newImg()] });
    }
    function onChangeImg(id) {
        return (value) => {
            onChange({
                imgs: map(imgs, (img) =>
                    img.id === id ? { ...img, ...value } : img
                ),
            });
        };
    }

    function onImgRemove(id) {
        return () => {
            onChange({
                imgs: filter(imgs, (img) => img.id !== id),
            });
        };
    }
    const buttons = (
        <>
            {showUp ? null : (
                <Button
                    className={`${s.btns} ${s.arrow}`}
                    style={{ flexGrow: 1 }}
                    icon={<ArrowUpOutlined />}
                    onClick={() => onChangeOrderRow(true)}
                />
            )}
            {showBottom ? null : (
                <Button
                    className={`${s.btns} ${s.arrow}`}
                    style={{ flexGrow: 1 }}
                    icon={<ArrowDownOutlined />}
                    onClick={() => onChangeOrderRow(false)}
                />
            )}
        </>
    );
    switch (type) {
        case rowTypes.text:
            return (
                <Input.Group
                    compact
                    style={{
                        display: 'flex',
                        marginBottom: '1rem',
                        position: 'relative',
                    }}
                >
                    <Input
                        className={s.input_row}
                        style={{
                            width: isSelectedLink ? '50%' : '1%',
                            zIndex: 1,
                        }}
                        value={value}
                        placeholder={'Содержимое'}
                        onChange={(e) => onChange({ value: e.target.value })}
                    />
                    <ConnectedSelect
                        onChange={onChange}
                        link={link}
                        style={{ flexBasis: '50%' }}
                        setIsSelectedLink={setIsSelectedLink}
                    />
                    {buttons}
                    <Button
                        icon={<MinusOutlined />}
                        className={`${s.btns} ${s.minus_btn}`}
                        onClick={onRemove}
                    />
                </Input.Group>
            );
        case rowTypes.imgs:
            return (
                <div>
                    {map(imgs, ({ id, height, width, value, link }, index) => {
                        return (
                            <ImgRow
                                height={height}
                                width={width}
                                link={link}
                                value={value}
                                key={id}
                                onChange={onChangeImg(id)}
                                setIsSelectedLink={setIsSelectedLink}
                            >
                                {index === 0 ? (
                                    <>
                                        {buttons}
                                        <Button
                                            style={{ flexGrow: 1 }}
                                            icon={<PlusOutlined />}
                                            onClick={onAddImg}
                                            className={`${s.plus}`}
                                        />
                                    </>
                                ) : null}
                                <Button
                                    style={{
                                        flexGrow: 1,
                                        borderRadius: 'unset',
                                    }}
                                    icon={<MinusOutlined />}
                                    onClick={
                                        index === 0 ? onRemove : onImgRemove(id)
                                    }
                                    className={`${s.minus_btn}`}
                                />
                            </ImgRow>
                        );
                    })}
                </div>
            );
        default:
            return null;
    }
};

const ImgRow = ({
    value,
    link,
    width,
    height,
    children,
    onChange,
    setIsSelectedLink,
}) => {
    return (
        <Input.Group
            compact
            style={{
                display: 'flex',
                flexWrap: 'wrap',
                marginBottom: '1rem',
            }}
        >
            <Input
                className={s.path_img_input}
                value={value}
                style={{ flexBasis: '50%', borderRadius: 'unset' }}
                placeholder={'Путь до изображения'}
                onChange={(e) => onChange({ value: e.target.value })}
            />
            <ConnectedSelect
                onChange={onChange}
                link={link}
                style={{ flexBasis: '50%' }}
                setIsSelectedLink={setIsSelectedLink}
            />
            <div className="collapse-input_size">
                <Input
                    placeholder={'Высота'}
                    style={{ width: 'fit-content' }}
                    value={height}
                    className={s.size_input}
                    onChange={(e) => onChange({ height: e.target.value })}
                />
            </div>
            <div className="collapse-input_size">
                <Input
                    value={width}
                    style={{ width: 'fit-content' }}
                    className={s.size_input}
                    placeholder={'Ширина'}
                    onChange={(e) => onChange({ width: e.target.value })}
                />
            </div>
            {children}
        </Input.Group>
    );
};

const ConnectedSelect = connect((state) => ({
    setting: state.appState.setting,
}))(({ setting, link, onChange, style, setIsSelectedLink }) => {
    const [isInput, setIsInput] = useState(isExternalLink(link));
    const [localLink, setLocalLink] = useState(link);
    const [isDropdown, setIsDropdown] = useState(false);
    const [isMainPage, setIsMainPage] = useState(false);
    useEffect(() => {
        setLocalLink(link);
    }, [link]);
    return isInput ? (
        <div className={'collapse-input_link'}>
            <Input
                style={style}
                placeholder={'Ссылка'}
                value={localLink}
                onChange={(e) => {
                    onChange({ link: e.target.value });
                }}
                onBlur={() => {
                    if (!localLink) {
                        setIsInput(false);
                        onChange({ link });
                    }
                }}
            />
        </div>
    ) : (
        <div className={s.wrap_input}>
            {isMainPage ? (
                <div className={s.link_control}>Главная</div>
            ) : (
                <div
                    className={s.link_control}
                    onClick={() => setIsDropdown((prev) => !prev)}
                >
                    Ссылка (на страницу или своя)
                </div>
            )}
            {isDropdown && (
                <div className={s.link_dropdown}>
                    <div
                        onClick={() => {
                            setIsSelectedLink(true);
                            setIsInput(true);
                            setLocalLink('');
                            setIsDropdown((prev) => false);
                        }}
                    >
                        Своя
                    </div>
                    <div
                        onClick={() => {
                            setIsSelectedLink(true);
                            onChange({ link: '/' });
                            setIsMainPage(true);
                            setIsDropdown((prev) => false);
                        }}
                    >
                        Главная
                    </div>
                </div>
            )}
        </div>
    );
});
